import Item from 'common/ITEMS/Item';

const items = {
  //region Blood
  //endregion
  //region Frost
  //endregion
  //region Unholy
  //endregion
  //region Shared
  //endregion
} satisfies Record<string, Item>;
export default items;
